import { useCurrentProject } from '@modules/projects/utils/useCurrentProject';
import { WorkflowVariableFragmentFragment, WorkflowVariableValueTypes, useGetProjectMembersQuery } from 'gql/index';
import { useCallback } from 'react';
import { validateWorkflowPrincipal } from '../types';

export const useUserVariableResolver = () => {
  const { projectId } = useCurrentProject();
  const { data: projectMembers } = useGetProjectMembersQuery({ projectId }, { select: p => p.projectMembers });

  const resolveUser = useCallback((variable: WorkflowVariableFragmentFragment | null | undefined) => {
    if (variable?.variableValueType != WorkflowVariableValueTypes.User || variable?.serializedValue == null) {
      return undefined;
    }

    const principalObject = JSON.parse(variable.serializedValue);


    const principalValidation = validateWorkflowPrincipal(principalObject);

    if (!principalValidation) return undefined;

    return projectMembers?.find(p => p.id == principalObject?.id);
  }, [projectMembers]);

  return resolveUser;
};